import { FormValidationDefinition } from "../../../../../../common/components/form/use-form";
import phoneNumberInputHelper from "../../../../../../common/components/form/input/phone-number/phone-number-input.helper";
import TaxiOfficerAddByRailyFormData from "./types/taxi-officer-add-by-raily-form-data";
import taxiOfficerAddByRailyFormValidationService from "./taxi-officer-add-by-raily-form-validation.service";

const getDefaultFormData = (): TaxiOfficerAddByRailyFormData => {
  return {
    firstName: "",
    lastName: "",
    email: "",
    username: "",
    password: "",
    passwordRepeat: "",
    phoneNumber: phoneNumberInputHelper.getEmptyValue(),
    alternativePhoneNumber: phoneNumberInputHelper.getEmptyValue(),
    taxiCorporationUuid: "",
  };
};

const getValidationDefinition =
  (): FormValidationDefinition<TaxiOfficerAddByRailyFormData> => {
    return {
      firstName: (values) =>
        taxiOfficerAddByRailyFormValidationService.validateFirstName(
          values.firstName
        ),
      lastName: (values) =>
        taxiOfficerAddByRailyFormValidationService.validateLastName(
          values.lastName
        ),
      email: (values) =>
        taxiOfficerAddByRailyFormValidationService.validateEmail(values.email),
      username: async (values) =>
        await taxiOfficerAddByRailyFormValidationService.validateUsername(
          values.username
        ),
      password: (values) =>
        taxiOfficerAddByRailyFormValidationService.validatePassword(
          values.password
        ),
      passwordRepeat: (values) =>
        taxiOfficerAddByRailyFormValidationService.validatePasswordRepeat(
          values.password,
          values.passwordRepeat
        ),
      phoneNumber: (values) =>
        taxiOfficerAddByRailyFormValidationService.validatePhoneNumber(
          values.phoneNumber
        ),
      alternativePhoneNumber: (values) =>
        taxiOfficerAddByRailyFormValidationService.validateAlternativePhoneNumber(
          values.alternativePhoneNumber
        ),
      taxiCorporationUuid: (values) =>
        taxiOfficerAddByRailyFormValidationService.validateTaxiCorporation(
          values.taxiCorporationUuid
        ),
    };
  };

const taxiOfficerAddByRailyFormHelper = {
  getDefaultFormData,
  getValidationDefinition,
};

export default taxiOfficerAddByRailyFormHelper;
